// extracted by mini-css-extract-plugin
export default {"wrapper":"AccountPage_wrapper__RqKCS","header":"AccountPage_header__DNbAZ"};